import { gql } from "@apollo/client";

export const GET_HEALTH_FORM = gql`
  query GetHealthUser(
    $affiliated: HEALTH_AFFILIATED_STATUS
    $noAffiliate: HEALTH_AFFILIATED_STATUS
    $pending: HEALTH_AFFILIATED_STATUS
  ) {
    getHealthUser(affiliated: $affiliated, noAffiliate: $noAffiliate, pending: $pending) {
      id
      documentType {
        id
        name
      }
      documentNumber
      documentExpirationDate
      state {
        id
        name
      }
      city {
        id
        name
      }
      ePS {
        id
        name
      }
      gender
      birthDate
      dependentChildren
      email
      firstName
      lastName
      phoneNumber
      secondaryPhoneNumber
      optionalPhoneNumber
      neighborhood
      isAdultSupervision
      file
      created
      modified
      isAffiliated
    }
  }
`;
